<template>
    <Layout>
      <b-modal
          id="modalPartidaActual"
          title="Agregar partida"
          title-class="font-18"
          size="xl"
          no-close-on-backdrop
          no-close-on-esc
          hide-footer
      >
        <b-overlay :show="isLoadingModal">
          <form class="needs-validation" @submit.prevent="guardarPartidaActualSubmit">
            <div class="form-row">
              <div class="form-group col-md-2">
                <label>Tipo</label>
                <select class="form-control" v-model="partida_actual.tipo" @change="cambiarTipo($event)">
                  <option value = "P">Partida</option>
                  <option value = "T">Titulo</option>
                </select>
              </div>
              <div class="form-group col-md-2">
                <label>Tipo</label>
                <select class="form-control" v-model="partida_actual.tipo_costo" @change="cambiarTipo($event)" >
                  <option value = "Costo directo">Costo directo</option>
                  <option value = "Costo indirecto">Costo indirecto</option>
                </select>
              </div>
              <div class="form-group col-md-2">
                <label>Codigo de partida </label>
                <input
                    class="form-control" v-model="partida_actual.codigo_partida"
                    :class="{ 'is-invalid': submittedNuevaPartida && $v.partida_actual.codigo_partida.$error }"
                    placeholder="00.00.00.00"
                />
                <div v-if="submittedNuevaPartida && $v.partida_actual.codigo_partida.$error" class="invalid-feedback">
                  <span v-if="!$v.partida_actual.codigo_partida.required">Este valor es requerido.</span>
                </div>
              </div>
              <div class="form-group col-md-6">
                <label>Nombre de la partida</label>
                <input
                    class="form-control" v-model="partida_actual.partida"
                    :class="{ 'is-invalid': submittedNuevaPartida && $v.partida_actual.partida.$error }"
                />
                <div v-if="submittedNuevaPartida && $v.partida_actual.partida.$error" class="invalid-feedback">
                  <span v-if="!$v.partida_actual.partida.required">Este valor es requerido.</span>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-2"   v-show="partida_actual.tipo=='P'">
                <label>Unidad de medida</label>
                <input
                    class="form-control" v-model="partida_actual.unidad_medida"
                    :class="{ 'is-invalid': submittedNuevaPartida && $v.partida_actual.unidad_medida.$error }"
                    :disabled="disable_partida_actual_um"
                />
                <div v-if="submittedNuevaPartida && $v.partida_actual.unidad_medida.$error" class="invalid-feedback">
                  <span v-if="!$v.partida_actual.unidad_medida.required">Este valor es requerido.</span>
                </div>
              </div>

              <div class="form-group col-md-2"  v-show="partida_actual.tipo=='P'">
                <label>Cantidad</label>
                <input
                    class="form-control" v-model="partida_actual.cantidad"
                    :class="{ 'is-invalid': submittedNuevaPartida && $v.partida_actual.cantidad.$error }"
                    :disabled="disable_partida_actual_cantidad"
                    @input="calcularSubtotal()"
                />
                <div v-if="submittedNuevaPartida && $v.partida_actual.cantidad.$error" class="invalid-feedback">
                  <span v-if="!$v.partida_actual.cantidad.required">Este valor es requerido.</span>
                  <span v-if="!$v.partida_actual.cantidad.decimal">Solos se adminte numeros.</span>
                </div>
              </div>
              <div class="form-group col-md-2"  v-show="partida_actual.tipo=='P'">
                <label>C. U.</label>
                <input
                    class="form-control" v-model="partida_actual.costo_unitario"
                    :class="{ 'is-invalid': submittedNuevaPartida && $v.partida_actual.costo_unitario.$error }"
                    :disabled="disable_partida_actual_costo_unitario"
                    @input="calcularSubtotal()"
                />
                <div v-if="submittedNuevaPartida && $v.partida_actual.costo_unitario.$error" class="invalid-feedback">
                  <span v-if="!$v.partida_actual.costo_unitario.required">Este valor es requerido.</span>
                  <span v-if="!$v.partida_actual.costo_unitario.decimal">Solos se adminte numeros.</span>
                </div>
              </div>
              <div class="form-group col-md-2"  v-show="partida_actual.tipo=='P'">
                <label>Subtotal</label>
                <input
                    class="form-control" v-model="partida_actual.subtotal"
                    :class="{ 'is-invalid': submittedNuevaPartida && $v.partida_actual.subtotal.$error }"
                    :disabled="disable_partida_actual_subtotal"
                />
                <div v-if="submittedNuevaPartida && $v.partida_actual.subtotal.$error" class="invalid-feedback">
                  <span v-if="!$v.partida_actual.subtotal.required">Este valor es requerido.</span>
                  <span v-if="!$v.partida_actual.subtotal.decimal">Solos se adminte numeros.</span>
                </div>
              </div>

              <div class="form-group col-md-2">
                <label>Activo</label>
                <select class="form-control" v-model="partida_actual.estado" >
                  <option value = "0">Inactivo</option>
                  <option value = "1">Activo</option>
                </select>
              </div>
              <div class="form-group col-md-2">
                <label>Tipo partida</label>
                <select class="form-control" v-model="partida_actual.tipo_partida" >
                  <option value = "0">Presupuesto base</option>
                  <option value = "1">Nueva</option>
                </select>
              </div>
              <!--<div class="form-group col-md-3">
                <label>Fecha</label>
                <VueCtkDateTimePicker
                    v-model="partida_actual.fecha"
                    :locale="'es'"
                    :input-size="'sm'"
                    :format="'YYYY-MM-DD'"
                    :formatted="'YYYY-MM-DD'"
                    :range="false"
                    :auto-close="true"
                    :only-date="true"
                    :no-header="true"
                    style="z-index: 100"
                    :class="{ 'is-invalid': submittedNuevaPartida && $v.partida_actual.fecha.$error }"
                />
                <div v-if="submittedNuevaPartida && $v.partida_actual.fecha.$error" class="invalid-feedback">
                  <span v-if="!$v.partida_actual.fecha.required">Este valor es requerido.</span>
                </div>
              </div>-->

            </div>
            <div class="form-row">
              <div class="col-md-12 text-right">
                <button type="submit" v-show="$can('partidas-modificar')"
                        class="btn btn-primary mt-4"><i class="fa fa-save"></i> Guardar
                </button>

              </div>

            </div>
          </form>
        </b-overlay>
      </b-modal>

        <div class="card">
            <b-overlay :show="isLoading" rounded="sm">
                <div class="card-body">
                    <div class="form-row">
                        <div class="form-group col-md-8">
                            <label>Expediente</label>
                            <v-select
                                    :options="expedientes"
                                    label="obra_expediente"
                                    :reduce="desc=>desc.expediente_id"
                                    v-model="expediente_id"
                                    @input="cargarPresupuesto()"
                            />
                        </div>
                        <div class="form-group col-md-2">
                          <label>Activo</label>
                          <select class="form-control" v-model="filtro_activo"  @change="cargarPresupuesto()">
                            <option value="-1">Todos</option>
                            <option value="0">No</option>
                            <option value="1">Si</option>
                          </select>

                        </div>
                        <div class="form-group col-md-2" >
                            <button class="btn btn-primary mt-4" v-on:click="onBtnExport" >ExportarCSV</button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <ag-grid-vue
                                    style="width: 100%; height: 400px"
                                    class="ag-theme-balham"
                                    :columnDefs="columnDefs"
                                    :rowData="rowData"
                                    :gridOptions="gridOptions"
                                    @grid-ready="onGridReady"
                            >
                            </ag-grid-vue>
                        </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12 text-right mt-3">
                        <h3>Total: S/ {{total}}</h3>
                      </div>

                    </div>
                </div>
            </b-overlay>

        </div>


    </Layout>
</template>

<script>
    import Layout from "../../layouts/main.vue";
    import appConfig from "@/app.config.json";
    //import PageHeader from "@/components/page-header";

    import {decimal, required} from "vuelidate/lib/validators";


    //import constantes from "../../../config/Constantes";
    /**
     * Dashboard Component
     */
    export default {
        page: {
            title: "Presupuesto",
            meta: [{ name: "description", content: appConfig.description }]
        },
        components: {
            Layout,

        },
        data() {
            return {

                title: "Presupuesto ",
                items: [
                    {
                        text: "Presupuesto",
                        href: "/"
                    },
                    {
                        text: "Lista",
                        active: true
                    }
                ],
                isLoading: false,
                gridApi: null,
                columnApi: null,
                gridOptions: {

                    defaultColDef: {
                        sortable: true,resizable: true
                    },
                },

                columnDefs:[],
                rowData:[],
                expedientes:[],
                expediente_id:null,
                total:0,
                ////OLD/////////
                codigo_carrera:null,
                indicador_selecionado:{ opciones:[]},
                indicadores:[],
                opciones:[],
                opcion_seleccionada:null,
                ///
                partida_actual:{},
                submittedNuevaPartida:false,
                isLoadingModal:false,
                disable_partida_actual_um:false,
                disable_partida_actual_cantidad:false,
                disable_partida_actual_costo_unitario:false,
                disable_partida_actual_subtotal:false,
                filtro_activo:"1"
                ////////////////
            };
        },
        watch:{
          'partida_actual.tipo':function (val){
            if(val=="T"){
              this.partida_actual.cantidad=0;
              this.partida_actual.costo_unitario=0;
              this.partida_actual.subtotal=0;
              this.partida_actual.unidad_medida="-";
              this.calcularSubtotal();
            }
          }
        },
        methods: {
            editarPartida(id){
              this.isLoading=true;
              this.axios.get(process.env.VUE_APP_BACKEND +"/api/partidas/"+id)
                  .then((response) => {
                    this.partida_actual=response.data;
                    //this.cambiarTipo();
                    this.$bvModal.show("modalPartidaActual");
                  })
                  .catch(()=>{
                    this.$swal('Cuidado',"Error cargando las partidas",'warning');
                  })
                  .finally(()=>this.isLoading=false)
            },
            guardarPartidaActual(){
              this.isLoadingModal = true;
              this.partida_actual.expediente_id = this.expediente_id;
              const url = this.partida_actual.id === 0
                  ? '/api/partidas'
                  : '/api/partidas/' + this.partida_actual.id;
              const requestMethod = this.partida_actual.id === 0 ? this.axios.post : this.axios.put;
              requestMethod(process.env.VUE_APP_BACKEND + url, this.partida_actual)
                  .then(() => {
                    this.cargarPresupuesto();
                    this.$bvModal.hide("modalPartidaActual");
                  })
                  .catch(() => {
                    this.$swal('error','Error agregando ó modificando','error');
                  })
                  .finally(() => {
                    this.isLoadingModal = false;
                    this.actualizar();
                  });



            },
            calcularSubtotal(){
              if(this.partida_actual.tipo_costo=="Costo directo"){
                this.partida_actual.subtotal=Math.round(this.partida_actual.costo_unitario*this.partida_actual.cantidad*100)/100;
              }
            },
            guardarPartidaActualSubmit(){
              this.submittedNuevaPartida = true;
              // stop here if form is invalid
              this.$v.$touch();
              console.log(this.$v);
              if(this.$v.partida_actual.$error==false){
                this.guardarPartidaActual();
              }
            },
            cargarExpedientes(){
                this.isLoading=true;
                this.axios.get(process.env.VUE_APP_BACKEND + "/api/expedientes")
                    .then((response)=>{
                        this.expedientes=response.data;
                    })
                    .finally(()=>this.isLoading=false)
            },
            cargarPresupuesto(){
                this.isLoading=true;
                this.axios.get(process.env.VUE_APP_BACKEND +"/api/expediente/presupuesto",
                    {
                      params: {
                        filtro_activo:this.filtro_activo,
                        expediente_id:this.expediente_id
                      }
                    })
                    .then((response) => {
                    this.rowData= response.data.partidas;
                    this.total=response.data.total;
                    //this.rowData=response.data;
                })
                .finally(()=>this.isLoading=false)
            },
            //////////////OLD
          onBtnExport() {
            this.gridApi.exportDataAsCsv();
          },

            abrirCarga(){
                this.$bvModal.show("modalUpload");
            },
            cargarOpciones(){

            },

            onGridReady(params) {
                this.gridApi = params.api;
                this.gridColumnApi = params.columnApi;
                this.gridApi.addEventListener('rowDoubleClicked',this.rowDoubleClicked);

            },

            rowDoubleClicked(row){
               //if(row.data.tipo_costo==="Costo directo")
              this.editarPartida(row.data.id);
            },
            cambiarTipo(){
              if(this.partida_actual.tipo=="P" && this.partida_actual.tipo_costo=="Costo directo"){
                this.partida_actual.costo_unitario='';
                this.partida_actual.cantidad='';
                this.partida_actual.unidad_medida='';
                this.disable_partida_actual_um=false;
                this.disable_partida_actual_costo_unitario=false;
                this.disable_partida_actual_cantidad=false;
                this.disable_partida_actual_subtotal=true;
              }

              if(this.partida_actual.tipo=="P" && this.partida_actual.tipo_costo=="Costo indirecto"){
                this.partida_actual.unidad_medida='-';
                this.partida_actual.costo_unitario='0';
                this.partida_actual.cantidad='0';
                this.partida_actual.subtotal='';

                this.disable_partida_actual_um=true;
                this.disable_partida_actual_costo_unitario=true;
                this.disable_partida_actual_cantidad=true;
                this.disable_partida_actual_subtotal=false;
              }

              if(this.partida_actual.tipo=="T" && this.partida_actual.tipo_costo=="Costo directo"){
                this.partida_actual.unidad_medida='-';
                this.partida_actual.costo_unitario='0';
                this.partida_actual.cantidad='0';
                this.partida_actual.subtotal='0';

                this.disable_partida_actual_um=true;
                this.disable_partida_actual_costo_unitario=true;
                this.disable_partida_actual_cantidad=true;
                this.disable_partida_actual_subtotal=true;
              }
              if(this.partida_actual.tipo=="T" && this.partida_actual.tipo_costo=="Costo indirecto"){
                this.partida_actual.tipo_costo="Costo directo";
              }
            },
        },
        beforeMount() {
            this.columnDefs= [
                { headerName: "ID", field: "id" ,width:90},
                { headerName: "Tipo", field: "tipo",width:50},
                {
                  headerName: "Codigo",
                  field: "codigo_partida",
                  filter: true,  floatingFilter: true,
                  width:120
                },
                { headerName: "Partida", field: "partida", width:350, filter: true,  floatingFilter: true,  },
                { headerName: "UM", field: "unidad_medida", width:90},
                { headerName: "Cant", field: "cantidad", width:90,  cellStyle: {textAlign: "right"}},
                { headerName: "C.U.", field: "costo_unitario", width:90,  cellStyle: {textAlign: "right"}},
                { headerName: "Subtotal", field: "subtotal", width:100,  cellStyle: {textAlign: "right"}},
                { headerName: "Actualizado", field: "updated_at", width:100},
                { headerName: "Tipo partida", field: "tipo_partida_str", width:150, filter: true,  floatingFilter: true},
                { headerName: "Estado", field: "estado_str", width:100},

                /*
                {
                    headerName: "Validado",
                    field: "validado",
                    resizable: true ,
                    width:"150px",
                    filter: true,
                    floatingFilter: true,
                },*/
            ];
            this.rowData= [

            ];

        },
        validations: {
          partida_actual:{
            tipo:{required},
            codigo_partida:{required},
            partida:{required},
            unidad_medida:{required},
            costo_unitario:{required,decimal},
            cantidad:{required,decimal},
            subtotal:{required,decimal},
          },
        },
        computed: {
        },
        mounted() {
            this.cargarExpedientes();
        },

    };
</script>
